import React, { memo, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Flex } from 'pcln-design-system'
import NavLink from '../NavLink'
import { headerLinkShape } from '../../utils/shapes'

function SmallNavDropdown({ className, backgroundColor, color, iconColor, iconName, label, links, target }) {
  const [isOpen, setOpen] = useState(false)
  const toggleOpen = () => setOpen(!isOpen)
  const dropdownIconName = isOpen ? 'ChevronUp' : 'ChevronDown'

  return (
    <Flex color={color} className={className} flexDirection='column'>
      <Button variation='link' size='large' onClick={toggleOpen}>
        <NavLink
          color={color}
          dropdownIconName={dropdownIconName}
          iconColor={iconColor}
          iconName={iconName}
          label={label}
          p={3}
          width='100%'
        />
      </Button>
      {isOpen && (
        <Flex bg={backgroundColor} flexDirection='column'>
          {links.map((link) => (
            <NavLink
              {...link}
              key={`sm-navlink-${link.label}`}
              color={color}
              iconColor={iconColor}
              py={3}
              px={4}
              target={target}
            />
          ))}
        </Flex>
      )}
    </Flex>
  )
}

SmallNavDropdown.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  iconColor: PropTypes.string,
  iconName: PropTypes.string,
  label: PropTypes.string,
  links: PropTypes.arrayOf(headerLinkShape).isRequired,
  target: PropTypes.string,
}

SmallNavDropdown.defaultProps = {
  className: '',
  backgroundColor: 'background.lightest',
}

export default memo(SmallNavDropdown)
